module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAMCAYAAAAH4W+EAAAACXBIWXMAAAsSAAALEgHS3X78AAABD0lEQVQ4y72U4W2DMBCFP7JAGKEbuPUCZRRnAKveoHQDKg9QsgEjtAtYeIN0A5jA/XORUBoTSNI+6WQJ2c8f7w6KlBJrpLQvgQp4BEpZAXpgkLWPwR7W+BZLQORyI6UWekegBdoY7HATiAA4qS3Xaw/UcyllQZT2DqhvBJhqBJoYbL0IRGn/IJE+z5h+A5/AYTIblcxMdaF9ETAx2D4LorSvgC6TwiiAzaVBlJcxMy0dBab7BaK0N8BHxvtNAIYrvjAHvOZ8j60qUkoo7evM5rMxrpUk1GVa9h6DdUeQcxO7j8Ea7iilfQO8nLYpBltuMmd294YAiME6YHfyeAuwyUC0/JHE+wn4mtSyP+t/6AceGH7Xq/UB8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/wave1.png
// module id = 1490
// module chunks = 3